/* eslint-disable no-bitwise */
(function () {
  angular
    .module('kareo.ui.shared.modules.api.k-npi-service', [])
    .factory('kNpiService', kNpiService);

  kNpiService.$inject = ['$http'];
  function kNpiService($http) {
    const svc = this;

    svc.isValidNPI = isValidNPI;
    svc.lookupNPI = lookupNPI;

    return svc;

    // ---------------------------------------------------------------------

    /*
     * Dear coder person... this is a compiled version of the coffeescript
     * algorithm originally found in admin-ui. Please don't blame me for the
     * useless comments or variable names.
     *
     * <3,
     * Russell
     *
     * BTW DID YOU KNOW THAT SHIFTING BY ONE BIT IS THE SAME AS
     * MULITPLYING BY 2?!?!?!!
     */
    function isValidNPI(npi) {
      var i, j, sum, tmp;

      npi = String(npi);

      // check that it begins with 1 or 2
      if ((npi.charAt(0) !== '1') && (npi.charAt(0) !== '2')) {
        return false;
      }

      /*
       * the NPI is a 10 digit number, but it could be
       * preceded by the ISO prefix for the USA (80840)
       * when stored as part of an ID card.  The prefix
       * must be accounted for, so the NPI check-digit
       * will be the same with or without prefix.
       * The magic constant for 80840 is 24.
       */

      i = npi.length;
      if ((i === 15) && (npi.substring(0, 5) === '80840')) {
        sum = 0;
      } else if (i === 10) {
        sum = 24; // to compensate for the prefix
      } else { // length must be 10 or 15 bytes
        return false;
      }

      /*
       * the algorithm calls for calculating the check-digit
       * from right to left

       * first, intialize the odd/even counter, taking into account
       * that the rightmost digit is presumed to be the check-sum
       * so in this case the rightmost digit is even instead of
       * being odd
       */

      j = 0;

      // now scan the NPI from right to left
      while (i--) {
        // only digits are valid for the NPI
        if (isNaN(npi.charAt(i))) {
          return false;
        }
        // this conversion works for ASCII and EBCDIC
        tmp = npi.charAt(i) - '0';

        // the odd positions are multiplied by 2
        // noinspection JSBitwiseOperatorUsage
        if (j++ & 1) {
          /*
           * instead of multiplying by 2, we can just shift-left by one bit
           * which is a faster way to multiply by two.  Same as (tmp * 2)
           */

          tmp <<= 1;
          if (tmp > 9) {
            /*
             * when the multiplication by 2 results in a two digit number
             * (i.e., greater than 9) then the * two digits are added up.  But
             * we know that the left digit must be '1' and the right digit must
             * be x mod 10.  In that case we can just subtract 10 instead of
             * 'mod'
             */

            tmp -= 10; // 'tmp mod 10'
            tmp++; // left digit is '1'
          }
        }
        sum += tmp;
      }

      // If the checksum mod 10 is zero then the NPI is valid
      return sum % 10 === 0;
    }

    function lookupNPI(npi) {
      return $http
        .get('/admin-ui/api/Shared/lookupNpi', {
          cache: true,
          params: {
            npi
          }
        })
        .then((response) => {
          return response.data;
        });
    }
  }
})();
